import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectUser(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/mall/user/select`,
    method: "POST",
    data,
  });
}

/**
 * 禁用
 * @param {*} data
 * @returns
 */
export function disableUser(data) {
  return request({
    url: `/admin/mall/user/disable`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteUser(data) {
  return request({
    url: `/admin/mall/user/delete`,
    method: "POST",
    data,
  });
}


/**
 * 修改
 * @param {*} data
 * @returns
 */
export function updateApi(data) {
  return request({
    url: `/admin/mall/user/update`,
    method: "POST",
    data,
  });
}
